import { useState } from "react";
import { PageHead, TabBar } from "../components/PageHead";
import { Directory } from "../components/ops/Directory";
import { Tasks } from "../components/ops/Tasks";
import { Shifts } from "../components/ops/Shifts";
import { Newsroom } from "../components/ops/Newsroom";
import { Leave } from "../components/ops/Leave";
import { Announcements } from "../components/ops/Announcements";
import { Referrals } from "../components/ops/Referrals";

const TABS = [["directory", "Staff Directory"], ["tasks", "Tasks & Delegation"], ["shifts", "Shift Calendar"], ["newsroom", "Newsroom Workflow"],
  ["leave", "HR Self-Service"], ["announcements", "Announcements"], ["referrals", "Referrals"]];
const VIEWS = { directory: Directory, tasks: Tasks, shifts: Shifts, newsroom: Newsroom, leave: Leave, announcements: Announcements, referrals: Referrals };

export default function Ops() {
  const [tab, setTab] = useState("directory");
  const View = VIEWS[tab];
  return (
    <div data-testid="ops-hub">
      <PageHead eyebrow="Portal B · Internal Operations Hub" title="Operations Hub">
        Peace FM is the first fully-wired entity. Directory, delegation, rosters, newsroom sign-offs and HR self-service in one place.
      </PageHead>
      <TabBar tabs={TABS} value={tab} onChange={setTab} />
      <div className="p-5 md:p-10"><View /></div>
    </div>
  );
}
